function isValidFileType<T extends readonly string[]>(file: File, allowedExtensions: T): boolean {
    const extension = file.type;
    return allowedExtensions.includes(extension);
}

export default isValidFileType;
